export const sections = [
  'home',
  'about',
  'experience',
  'skills',
  'education',
];
